module.exports = __webpack_public_path__ + "img/Junny.d6456cd5.png";